import { render } from "./rangeBarChart.vue?vue&type=template&id=3889dff9&scoped=true"
import script from "./rangeBarChart.vue?vue&type=script&lang=js"
export * from "./rangeBarChart.vue?vue&type=script&lang=js"

import "./rangeBarChart.vue?vue&type=style&index=0&id=3889dff9&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Usuario\\Documents\\Git-Repositorios\\edge_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3889dff9"]])

export default __exports__